import { onCLS, onFCP, onINP, onLCP, onTTFB } from 'web-vitals';

const sendToConsole = (metric) => {
  if (import.meta.env.DEV) {
    console.log(`[WebVitals] ${metric.name}`, {
      value: metric.value,
      id: metric.id,
      rating: metric.rating,
      delta: metric.delta,
    });
  }
};

export const initWebVitals = () => {
  onCLS(sendToConsole);
  onINP(sendToConsole);
  onLCP(sendToConsole);
  onFCP(sendToConsole);
  onTTFB(sendToConsole);
};
